import { MyUploadedDocument } from '@/app/my-uploaded-documents/entities/my-uploaded-document.entity'

export interface MyUploadedDocumentState {
    documents: MyUploadedDocument[]
    hasLoaded: boolean
    error?: string
}

export const state: MyUploadedDocumentState = {
    documents: [],
    hasLoaded: false,
    error: undefined
}


